import React from 'react'
import { Heading, Pane } from 'evergreen-ui'
import { useCustomTheme } from '/fiweb/lib/theme'
import CardSection from '/~/components/AllCampaigns/CardSection'
import { useFinishedCampaignCardsQuery } from '/~/types/graphql'
import { normalizeNewApiCampaignCards, normalizeOldApiCampaignCards } from '/~/utils/campaignCard'
import { useBreakpoint } from '/fiweb/lib'
import { PublishedCampaignCardState, useGetPublishedCampaignCardsByStateQuery } from '/~/types/issuer-graphql'
import { client } from '/~/lib/issuer-client/client'
import { sortCampaignCards } from '/~/utils/arraySorting'
import { CardTypeEnum } from '/fiweb/components/CampaignCard/types'
import { useWindowScrollPosition } from 'rooks'

const FinishedCampaigns = () => {
  const { colors, spacing } = useCustomTheme()
  const { medium } = useBreakpoint()
  const { data, loading: oldApiLoading } = useFinishedCampaignCardsQuery({ variables: { pageSize: 1000 } })
  const [cardsShown, setCardsShown] = React.useState(6)
  const bottomRef = React.useRef<HTMLDivElement>()
  const scrollPos = useWindowScrollPosition()

  const { data: newApiData, loading: newApiLoading } = useGetPublishedCampaignCardsByStateQuery({
    variables: { state: [PublishedCampaignCardState.FINISHED, PublishedCampaignCardState.ARCHIVED] },
    skip: !client,
    client,
  })

  const cardList = React.useMemo(
    () => [
      ...normalizeOldApiCampaignCards(data?.finishedCampaignCards?.list || []),
      ...normalizeNewApiCampaignCards(newApiData?.publishedCampaignCardsByState || []),
    ],
    [data, newApiData],
  )

  const cards = React.useMemo(() => sortCampaignCards(cardList || [], CardTypeEnum.FINISHED), [cardList])

  React.useLayoutEffect(() => {
    if (bottomRef.current && cards.length > 0) {
      if (bottomRef.current?.getBoundingClientRect().top < window.innerHeight * 1.5) {
        setCardsShown(Math.min(cardsShown + 6, cards.length))
      }
    }
  }, [cards, scrollPos])

  return (
    <Pane width='100%' display='flex' flexDirection='column' alignItems='center'>
      <Pane backgroundColor={colors.fiDark10} width='100%'>
        <CardSection
          cards={cards.slice(0, cardsShown)}
          name='finished'
          loading={oldApiLoading || newApiLoading}
          title={
            <Heading
              is='h1'
              size={medium ? 500 : 600}
              textAlign={medium ? 'center' : 'start'}
              marginBottom={spacing.xs}
            >
              Avsluttede emisjoner
            </Heading>
          }
          description='Her kan du se emisjoner som allerede er gjennomført.'
          ignoreAdCard
        />
        <Pane ref={bottomRef} />
      </Pane>
    </Pane>
  )
}

export default FinishedCampaigns
